import React from 'react';
import cx from 'classnames';

import styles from './styles.css';

const Loader = ({ classes }) => {
  const containerClasses = cx(
    {
      [styles.container]: true,
    },
    classes
  );

  return (
    <span className={containerClasses}>
      <span className={styles.dot} />
      <span className={styles.dot} />
      <span className={styles.dot} />
      <span className={styles.dot} />
    </span>
  );
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/index.js